import { render } from "./NotificationComponent.vue?vue&type=template&id=ac6c2db6"
import script from "./NotificationComponent.vue?vue&type=script&lang=js"
export * from "./NotificationComponent.vue?vue&type=script&lang=js"

import "./NotificationComponent.vue?vue&type=style&index=0&id=ac6c2db6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__